const view = () => import('../components/view.vue');
const emptyView = () => import('../components/emptyView.vue');
const layout = () => import('../components/layout.vue');

// 参数说明:
// meta {
//   title: 'title', // 设置该路由在侧边栏和面包屑中展示的名字
//   breadcrumb: false, //  如果设置为false，则不会在breadcrumb面包屑中显示(默认为true)
//   showBack: false, // 如果设置为true，则会在面包屑下方显示返回按钮，（返回路由为面包屑中当前的路由的前一个路由，并且会将参数带过去，有返回按钮的需注意参数携带过来）
//   activeMenu: '/article/list', // 高亮设置的路由的侧边栏菜单，而不使用自身路由匹配侧边栏菜单
// }

export default [
  // 全屏路由
  { path: '/', redirect: '/index' },
  { path: '/login', component: () => import('../pages/login/login.vue'), meta: { title: '登录' } },
  { path: '/findpassword', component: () => import('../pages/login/find_password.vue'), meta: { title: '找回密码' } },
  { path: '/resetpassword', component: () => import('../pages/login/reset_password.vue'), meta: { title: '重置密码' } },
  { path: '/wechatlogin', component: () => import('../pages/login/wechat_login.vue'), meta: { title: '微信登录' } },
  { path: '/bindaccount', component: () => import('../pages/login/bind_account.vue'), meta: { title: '绑定账号' } },
  // {
  //   path: '/redirect',
  //   component: layout,
  //   children: [{ path: '/redirect/:path(.*)', component: () => import('@/components/redirect.vue'), meta: {} }],
  // },

  // 套壳路由
  {
    path: '',
    component: layout,
    meta: { title: '报表', langCode: 'home', breadcrumb: false },
    children: [
      {
        path: '/index',
        component: view,
        meta: { title: 'Index', langCode: 'index' },
        children: [{ path: '', component: () => import('../pages/dashboard/index.vue'), meta: { title: 'Index', langCode: 'index', breadcrumb: false } }],
      },
      {
        path: '/homepage',
        component: view,
        meta: { title: '首页', langCode: 'homepage' },
        children: [{ path: '', component: () => import('../pages/dashboard/dashboard2.vue'), meta: { title: '首页', langCode: 'homepage', breadcrumb: false } }],
      },
      {
        path: '/dashboard',
        component: view,
        meta: { title: 'Dashboard', langCode: 'dashboard' },
        children: [
          { path: '', component: () => import('../pages/dashboard/dashboard.vue'), meta: { title: 'Dashboard', langCode: 'dashboard', breadcrumb: false } },
          {
            path: 'accountDeviceDetail',
            component: () => import('../pages/deviceDetail/deviceDetail.vue'),
            meta: { title: '设备详情', langCode: 'device_detail_sbxq', activeMenu: '/dashboard', showBack: true },
          },
        ],
      },
      {
        path: '/messageCenter',
        component: view,
        meta: { title: '消息中心', langCode: 'messageCenter' },
        children: [{ path: '', component: () => import('../pages/base/messageCenter/messageCenter.vue'), meta: { title: '消息中心', langCode: 'messageCenter', breadcrumb: false } }],
      },
    ],
  },

  {
    path: '/home',
    component: layout,
    meta: { title: '报表', langCode: 'home' },
    children: [
      { path: 'report', component: () => import('../pages/report/report.vue'), meta: { title: '运行记录', langCode: 'report' } },
      { path: 'cleanscore', component: () => import('../pages/cleanscore/cleanscore.vue'), meta: { title: '清洁得分', langCode: 'cleanscore' } },
      { path: 'usageweek', component: () => import('../pages/usageweek/usageweek.vue'), meta: { title: '区域周报表', langCode: 'usageweek' } },
      { path: 'usagemonth', component: () => import('../pages/usagemonth/usagemonth.vue'), meta: { title: '区域月报表', langCode: 'usagemonth' } },
      { path: 'routeanalysis', component: () => import('../pages/routeanalysis/routeanalysis.vue'), meta: { title: '路线分析', langCode: 'routeanalysis' } },
    ],
  },

  {
    path: '/account',
    component: layout,
    meta: { title: '账号', langCode: 'account' },
    redirect: '/account/company',
    children: [
      {
        path: 'company',
        component: () => import('../pages/company/company.vue'),
        meta: { title: '公司管理', langCode: 'account_company' },
      },
      {
        path: 'manage',
        component: view,
        meta: { title: '个人中心', langCode: 'account_manage' },
        children: [
          { path: '', component: () => import('../pages/accountManage/accountManage.vue'), meta: { title: '个人中心', langCode: 'account_manage', breadcrumb: false } },
          {
            path: 'safe',
            component: () => import('../pages/accountManage/accountSafe.vue'),
            meta: { title: '账号安全', langCode: 'account_safe_zhaq', activeMenu: '/account/manage', showBack: true },
          },
        ],
      },
    ],
  },
  {
    path: '/rent',
    component: layout,
    meta: { title: '租赁', langCode: 'rent' },
    redirect: '/rent/contract',
    children: [
      {
        path: 'contract',
        component: view,
        meta: { title: '我的合同', langCode: 'rent_contract' },
        children: [
          { path: '', component: () => import('../pages/contract/contract.vue'), meta: { title: '我的合同', langCode: 'rent_contract', breadcrumb: false } },
          {
            path: 'accountContractDetail',
            component: () => import('../pages/contractDetail/contractDetail.vue'),
            meta: { title: '合同详情', langCode: 'contract_detail_htxq', showBack: true, activeMenu: '/rent/contract' },
          },
        ],
      },
      {
        path: 'myAccount',
        component: view,
        meta: { title: '我的账单', langCode: 'rent_myAccount' },
        children: [
          { path: '', component: () => import('../pages/myAccount/myAccount.vue'), meta: { title: '我的账单', langCode: 'rent_myAccount', breadcrumb: false } },
          {
            path: 'payConfirm',
            component: () => import('../pages/myAccount/payConfirm.vue'),
            meta: { title: '确认付款', langCode: 'pay_confirm_que_ren_fu_kuan', activeMenu: '/rent/myAccount', showBack: true },
          },
          {
            path: 'invoiceRecord',
            component: () => import('../pages/myAccount/invoiceRecord.vue'),
            meta: { title: '发票记录', langCode: 'invoice_record_fa_piao_ji_lu', activeMenu: '/rent/myAccount', showBack: true },
          },
          {
            path: 'paymentInfo',
            component: () => import('../pages/myAccount/payConfirm.vue'),
            meta: { title: '付款详情', langCode: 'pay_confirm_fkxq', activeMenu: '/rent/myAccount', showBack: true },
          },
          {
            path: 'refundDetail',
            component: () => import('../pages/myAccount/refundDetail.vue'),
            meta: { title: '退款详情', langCode: 'refund_detail_tkxq', activeMenu: '/rent/myAccount', showBack: true },
          },
          {
            path: 'payDeposit',
            component: emptyView,
            meta: { title: '应付押金', langCode: 'pay_deposit_ying_fu_ya_jin' },
            children: [
              {
                path: '',
                component: () => import('../pages/myAccount/payDeposit.vue'),
                meta: { title: '应付押金', langCode: 'pay_deposit_ying_fu_ya_jin', activeMenu: '/rent/myAccount', showBack: true, breadcrumb: false },
              },
              {
                path: 'paymentInfo',
                component: () => import('../pages/myAccount/payConfirm.vue'),
                meta: { title: '付款详情', langCode: 'pay_deposit_fkxq', activeMenu: '/rent/myAccount', showBack: true },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/service',
    component: layout,
    meta: { title: '售后', langCode: 'service' },
    redirect: '/service/order',
    children: [
      {
        path: 'order',
        component: view,
        meta: { title: '我的工单', langCode: 'service_order' },
        children: [
          { path: '', component: () => import('../pages/order/order.vue'), meta: { title: '我的工单', langCode: 'service_order', breadcrumb: false, keep: 'order' } },
          {
            path: 'detail',
            component: emptyView,
            meta: { title: '工单详情', langCode: 'order_detail_gdxq' },
            children: [
              {
                path: '',
                redirect: '/service/order/detail/detail',
              },
              {
                path: 'detail',
                component: () => import('../pages/order/orderDetail.vue'),
                meta: { title: '工单详情', langCode: 'order_detail_gdxq', activeMenu: '/account/order', breadcrumb: false, showBack: true },
              },
              {
                path: 'accountDeviceDetail',
                component: () => import('../pages/deviceDetail/deviceDetail.vue'),
                meta: { title: '设备详情', langCode: 'device_detail_sbxq', activeMenu: '/account/order', showBack: true },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/other',
    component: layout,
    meta: { title: '设备', langCode: 'other' },
    redirect: '/other/location',
    children: [
      {
        path: 'location',
        component: view,
        meta: { title: '项目管理', langCode: 'other_location' },
        children: [
          { path: '', component: () => import('../pages/location/locationMange.vue'), meta: { title: '项目管理', langCode: 'other_location', breadcrumb: false } },
          // {
          //   path: 'accountLocationArea',
          //   component: () => import('../pages/location/locationArea.vue'),
          //   meta: { title: '区域管理', langCode: 'location_area_qu_yu_guan_li', activeMenu: '/other/location', showBack: true },
          // },
        ],
      },
      {
        path: 'device',
        component: view,
        meta: { title: '我的设备', langCode: 'other_device' },
        children: [
          { path: '', component: () => import('../pages/device/device.vue'), meta: { title: '我的设备', langCode: 'other_device', breadcrumb: false, keep: 'device' } },
          {
            path: 'accountDeviceDetail',
            component: emptyView,
            children: [
              {
                path: '',
                component: () => import('../pages/deviceDetail/deviceDetail.vue'),
                meta: { title: '设备详情', langCode: 'device_detail_sbxq', activeMenu: '/other/device', showBack: true },
              },
            ],
          },
        ],
      },
      {
        path: 'distribution',
        component: () => import('../pages/distribution/distribution.vue'),
        meta: { title: '设备分配', langCode: 'other_distribution' },
      },
    ],
  },
  // 404页面
  { path: '*', component: () => import('../pages/login/notfound.vue'), meta: { title: '404' } },
];
